import media from './media'
import pseudo from './pseudo'
import palette from './palette'
import sizes from './sizes'
import font from './font'

export {
  media,
  pseudo,
  palette,
  sizes,
  font,
}

export default {
  palette,
  sizes,
  font,
}


// WEBPACK FOOTER //
// ./src/style/index.js